import{jsx as e}from"react/jsx-runtime";import t from"styled-components";import{withVDSManager as o}from"@vds-core/utilities";import{ColorTokens as i}from"@vds-tokens/color";import{TypographyTokens as r}from"@vds-tokens/typography";import{Fonts as n}from"@vds-core/typography";const l={children:void 0,viewport:"desktop"},a=t.td.withConfig({displayName:"StyledCell",componentId:"VDS__sc-r2tlfn-0"})`
  font-size: ${function({viewport:e}){return"mobile"===e?r.fontsize.body[12].value:r.fontsize.body[16].value}};
  line-height: ${function({viewport:e}){return"mobile"===e?r.lineheight.body[16].value:r.lineheight.body[20].value}};
  letter-spacing: ${function({viewport:e}){return"mobile"===e?0:r.letterspacing.wide.value}};
  font-weight: ${r.fontweight.regular.value};
  font-family: ${function({viewport:e}){return"mobile"===e?n.VerizonNHGeTX:n.VerizonNHGeDS}};
  color: ${i.elements.primary.onlight.value};
  text-align: left;
  vertical-align: top;
  &:active,
  &:focus,
  &:hover {
    outline: none;
  }
`,p=function(t){return e(a,Object.assign({},t,{children:t.children}))};p.defaultProps=l;var s=o(p);export{s as default};
